import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl } from '../../../utils/network-utils';
import { getImageAsEmbedNew, removeNonAllowedCharactersFromPDF, urlToArrayBuffer } from '../../../utils/utils.common';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }


  async getDriverGrivenceReport(payload, user) {

    const response = await fetch('assets/documents/driver-grievance-report.pdf');
    let pdfBuffer = await response.arrayBuffer();

    pdfBuffer = await this.fillPDF(pdfBuffer, payload, user);

    if (pdfBuffer) {
      const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'driver-grievance-report.pdf'
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }


  async fillPDF(pdfBuffer: ArrayBuffer, payload, user): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();
    const profileLogo: any = await urlToArrayBuffer(user.profileImageURL);
    const companyLogo = await getImageAsEmbedNew(pdfDoc, user.profileImageURL, profileLogo);
    //Reporting Details
    form.getTextField('company_name').setText(payload.createdBy.toString());
    if (companyLogo)
      form.getTextField('company_logo').setImage(companyLogo);
    form.getTextField('dos').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || ''.toString());
    form.getTextField('reporting_time').setText('Reporting time');
    form.getTextField('complaint_id').setText("Client Id");
    form.getTextField('reported_driver').setText(payload.driver.displayName.toString());
    // //temp address on incident_address
    form.getTextField('incident_address').setText(payload.jobOriginAddress.toString());
    // //Member
    form.getTextField('member_name').setText(payload.priorityClient.displayName.toString());
    form.getTextField('member_cellphone').setText(payload.priorityClient.cellPhone.toString());
    form.getTextField('member_contactNo').setText(payload.priorityClient.contactNumber.toString());
    form.getTextField('client_id').setText(payload.memberId.toString());
    form.getTextField('member_weight').setText("Weight Missing" || '0');
    form.getTextField('member_gender').setText('Male' || '');
    form.getTextField('insurance_id').setText(payload.priorityClient.clientId.toString());
    form.getTextField('member_dob').setText(payload.dob.toString());
    form.getTextField('member_escort').setText(payload.noOfEscorts ? payload.noOfEscorts.toString() : '');
    // //Trip Infomation
    form.getTextField('pu_address').setText(payload.jobOriginAddress.toString());
    form.getTextField('do_address').setText(payload.jobDestinationAddress.toString());
    form.getTextField('trip_status').setText(payload.status.toString());
    form.getTextField('trip_notes').setText(payload.companyNote.slice(0, 50));
    form.getTextField('trip_miles').setText(payload.milage.toString());
    form.getTextField('pu_time').setText(moment(payload.scheduleTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('do_time').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('act_pu_time').setText(moment(payload.scheduleTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('act_do_time').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('cancel_reason').setText(payload.changeReason.toString());
    form.getTextField('broker_name').setText(payload.payor.toString());
    form.getTextField('trip_id').setText(payload.tripId.toString());
    form.getTextField('los').setText(payload.tripRequirement.toString());
    // // Vin missing
    form.getTextField('vin').setText("HardCoded" || '0');

    // //timestamps
    form.getTextField('accepted_time').setText("HardCode" || "0");
    form.getTextField('onscene_time').setText(moment(payload.job.trackInfoJob.jobArrived.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('started_time').setText(moment(payload.job.trackInfoJob.jobStarted.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('ended_time').setText(moment(payload.job.trackInfoJob.jobFinished.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('accepted_coordinate').setText("Coordinates Missing");
    form.getTextField('onscene_coordinate').setText(`${payload.job.trackInfoJob.jobArrived.coords[0]} - ${payload.job.trackInfoJob.jobArrived.coords[1]}`);
    form.getTextField('started_coordinate').setText(`${payload.job.trackInfoJob.jobStarted.coords[0]} - ${payload.job.trackInfoJob.jobStarted.coords[1]}`);
    form.getTextField('ended_coordinate').setText(`${payload.job.trackInfoJob.jobFinished.coords[0]} - ${payload.job.trackInfoJob.jobFinished.coords[1]}`);

    form.getTextField('driver_grievance').setText(payload.driverNote.toString());
    form.getTextField('driver_signature').setText(payload.signatureImage || "N/A");


    // form.getTextField('provider_company').setText('test');
    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;


  }




  getReportsWithNgrx(data): Observable<any> {
    const userId = data._id;
    delete data._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_REPORTS_URL + `${userId}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverPdfReport(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('check', data.mailCheck);
    params = params.append('endDate', data.endDate);
    params = params.append('startDate', data.startDate);

    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_DRIVER_PDF_REPORT_URL + `${data.driverId}?`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getPaymentPdfReport(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('endDate', data.endDate);
    params = params.append('startDate', data.startDate);

    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_PAYMENT_PDF_REPORT_URL + `${data.id}?`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriversScore(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_KPI_SCORE, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
